import { render, staticRenderFns } from "./InfotVacation.vue?vue&type=template&id=5dda2c68&"
import script from "./InfotVacation.vue?vue&type=script&lang=js&"
export * from "./InfotVacation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports